import { Image, useStyles } from '@archipro-design/aria';

import { Swiper, SwiperSlide } from 'swiper/react';

import * as S from './CompanyImages.style';

import SwiperCore from 'swiper';
import { Pagination } from 'swiper/modules';
import { useProfessionalInitialRouteData } from '~/modules/professional/hook/use-professional-initial-route-data';
import type { CompanyImagesProps } from '@modules/professional/component/about-tab/company-images/CompanyImages';
SwiperCore.use([Pagination]);

export const CompanyImagesMobile: React.FC<CompanyImagesProps> = (props) => {
    const { companyImages, isPortraitOnly } = props;

    const { css } = useStyles({
        isPortraitOnly,
        placementCount: companyImages?.length ?? 0,
    });
    const { Title } = useProfessionalInitialRouteData();
    return (
        <div className={css(S.MobileCompanyImageWrapper)}>
            <Swiper
                spaceBetween={6}
                loop={false}
                centeredSlides={true}
                slidesPerView={1.095}
                pagination={{ type: 'fraction', el: '.swiper-pagination' }}
            >
                {companyImages?.map((img, index) => (
                    <SwiperSlide
                        key={index}
                        className={css({
                            '& img': {
                                objectFit: img.isPortrait ? 'contain' : 'cover',
                            },
                        })}
                    >
                        <Image
                            src={img.src}
                            width={img.width}
                            height={img.height}
                            alt={Title}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
            {companyImages?.length > 1 && (
                <div className={'swiper-pagination'} />
            )}
        </div>
    );
};
